import Loading from './index.vue'

export default {
	install (Vue, options = {}) {
		
		let loading = null;
		
		const VueLoading = Vue.extend(Loading);

		function $loading(text = '', visible = false) {
			
			if (!loading) {
				
				loading = new VueLoading();

				loading.$mount();
				
				document.querySelector(options.container || 'body').appendChild(loading.$el);
			}
			return loading.show(text, visible, this);
		}

		Vue.prototype.$loading = $loading;
	}
}